module.exports = __webpack_public_path__ + "static/media/centos-logo.5c3cfd3d.png";